import React from 'react';
import SimpleButton from '../SimpleButton';
import SalesforceFormRaw from '../SalesforceFormRaw';
import FadeUp from '../animations/FadeUp';

const form = (
    <form className="bg-white flex flex-col md:flex-row items-center w-full p-4 rounded-full justify-between">
        <input
            type="email"
            name="email"
            placeholder="Email"
            className="p-4 w-full focus:ring-0 border-0 font-inter bg-transparent"
            required
        />
        <SimpleButton
            size="large"
            label="Join Newsletter"
            textColor="text-white"
            bgColor="bg-custom-black whitespace-nowrap"
            onClick={() => {
            }}
        />
    </form>
)

const StayInTouch: React.FC = () => {
    return (
        <div className="bg-custom-black py-14 md:py-28 px-4 md:px-0">
            <FadeUp>
                <div className="container mx-auto flex flex-col lg:flex-row gap-12 lg:gap-0 items-center justify-between px-4 md:px-0">
                    <div className="w-full lg:w-1/2 text-center">
                        <h2 className="text-3xl font-semibold text-custom-green font-jarkarta">Not ready yet? Stay In Touch!</h2>
                    </div>
                    <SalesforceFormRaw
                        debug={false}
                        page="cyber_range_landing_newsletter"
                        formElement={form}
                        enableReCAPTCHA={false}
                    />
                </div>
            </FadeUp>
        </div>
    );
};

export default StayInTouch;
